import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=50a09d92"
import script from "./pdf-viewer.vue?vue&type=script&lang=js"
export * from "./pdf-viewer.vue?vue&type=script&lang=js"
import style0 from "./pdf-viewer.vue?vue&type=style&index=0&id=50a09d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports